var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 52,
    height: 53,
    transform: "translate(-0.039 -0.338)",
    fill: "#956ae1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_362",
    "data-name": "Groupe 362",
    transform: "translate(-0.299)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 39.5,
    cy: 39.5,
    r: 39.5,
    transform: "translate(0.299 0)",
    fill: "#f4deff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_136",
    "data-name": "Groupe 136",
    transform: "translate(13.338 13.338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_135",
    "data-name": "Groupe 135",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_546",
    "data-name": "Trac\\xE9 546",
    d: "M52.062,42.065l-11-11.013a1.539,1.539,0,0,0-2.176,0l-5.078,5.083a.855.855,0,0,1-1.21,0l-16.185-16.2a.861.861,0,0,1,0-1.215l5.078-5.083a1.538,1.538,0,0,0,0-2.174L10.487.451a1.539,1.539,0,0,0-2.176,0L3.974,4.792a13.542,13.542,0,0,0,0,19.117l24.6,24.625a13.421,13.421,0,0,0,9.481,3.96h.073a13.419,13.419,0,0,0,9.449-3.86l4.473-4.384a1.537,1.537,0,0,0,.011-2.185M9.4,3.714l8.829,8.837L16.1,14.682,7.27,5.845Zm28.674,45.7a10.362,10.362,0,0,1-7.321-3.058L6.15,21.735A10.467,10.467,0,0,1,5.172,8.1l8.771,8.779a3.941,3.941,0,0,0,.293,5.234l16.184,16.2a3.931,3.931,0,0,0,5.231.3l8.726,8.734a10.36,10.36,0,0,1-6.3,2.08m8.565-4.169-8.795-8.8,2.13-2.131,8.817,8.825Z",
    transform: "translate(-0.309 0.044)",
    fill: "#956ae1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelIcon);
export default __webpack_public_path__ + "static/media/tel-icon.b5e10f31cd7a049e97aebf2cfda98723.svg";
export { ForwardRef as ReactComponent };